import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router";
import { register } from "@redux/slices/auth";
import { RegisterDataSchema } from "@/schemas/auth";
import { enqueueSnackbar } from "notistack";
import { updateUserById} from "@redux/slices/settings";
import { RegisterData } from "@typedefs/auth";
import { supabaseClient } from "@/supabase/app";
import { updateUserApiKey } from "@redux/slices/auth";

// Define the email schema with zod
const emailSchema = z.object({
  email: z.string().min(1, "Email is required").email("Invalid email address"),
});

interface Props {
  showModal: boolean;
  handleCloseModal: () => void;
  id: number;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  borderRadius: "6px",
  backgroundColor: "#F4F4F4",
  color: "#3F3F46",
};

const UpdateUser: React.FC<Props> = ({ showModal, handleCloseModal,id }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [isPasswordVisible, setPasswordVisibility] = useState(false);

  function onHandleEye() {
    if (isPasswordVisible) {
      setPasswordVisibility(false);
    } else {
      setPasswordVisibility(true);
    }
  }
  // Use react-hook-form to manage form state and validation
  const {
    register: registerInput, // `registerInput` to avoid conflict with `register` function
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(RegisterDataSchema), // Use Zod resolver for form validation
  });
  const [data, setData] = useState<RegisterData>({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    apikey: "",
  });
  const [error, setError] = useState<string | null>(null);


  // Password change function
const handleChangePassword = async () => {
  
    const { error } = await supabaseClient.auth.updateUser({
      password: data.password,
    });
  
    if (error) {
      console.log(error.message);
      console.log("I am in error")
    } else {
      // setSuccess(true);
      console.log('Password changed successfully');
    }
  };


  
const UploadData = async () => {
   
    const check = await updateUserApiKey(id,data.apikey)
    if(check){
        handleCloseModal();
        console.log("Success")
        enqueueSnackbar(`Api-key updated`, {
            variant: "success",
          });
    }
    else{   
        enqueueSnackbar(`Unable to update api key`, {
            variant: "error",
          });
    }
  }; 


  const handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {

        if(data.apikey == ""){
            console.log("Its empty")
            setError("Field Empty");
        }
        else{
            UploadData();
            console.log(data.apikey)

        }
    
    } catch (error: any) {}

    setLoading(false);
  };

  const [repeatPassword, setRepeatPassword] = useState("");

  return (
    <Modal
      open={showModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="px-8 py-16">
          <h2 className="text-gray font-bold text-[25px] mb-7">Update User</h2>

          {/* Single form for all fields */}
          <form onSubmit={handleOnSubmit}>
           

            <h2 className="text-gray font-bold text-lg mt-5 mb-4">Api Key</h2>

            <input
              type="text"
              value={data.apikey}
              className="flex mt-5  h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
              placeholder="Api Key"
              onChange={(e) => setData({ ...data, apikey: e.target.value })}
              //   required
            />
            {error && <p style={{ color: "red" }}>{error}</p>}

            <Button className="w-full mt-8" type="submit">
              {/* {loading ? "Updating..." : "Update"} */}
              Update
            </Button>
          </form>
        </div>
      </Box>
    </Modal>
  );
};

export default UpdateUser;
